
import React from 'react';  
class LargeImage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          value: null,
        };
      }

      //We may have to have a unique clip-path name per LargeImage
    render(){ 
        var iw = this.props.imageWidth;
        var ih = this.props.imageHeight;
        var sw = this.props.width;
        var sh = this.props.height; 
        return (<div>
             <svg width= {sw} height={ih}>
              <clipPath id="clip1">
              {/* {(iw-sw)/2} */}
              {/*Below hides left side but still draws right side */}
                <rect x={0} y={0} width={iw-(iw-sw)/2} height={ih}></rect>  
              </clipPath>
              {/* x={((sw-iw)/2)} */}
               <image href={`/images/${this.props.imageName}`} clipPath="url(#clip1)" x={-(iw-sw)/2}></image>    
             
            </svg>
        </div>)
    }
}

export default LargeImage;